import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasPermission, isSocialCreative } from "utils/common";
import { CV, VERSION_STATUS } from "utils/constants";
import { Button } from "rhombus-react";
import { socialUnpublishVersion } from "reducers/CreativeVersions";

export default function UnpublishSocialVersionsButton({ libraryId }) {
	const dispatch = useDispatch();
	const { currentSelection, versions, creativeDetails, user } = useSelector((state) => {
		return {
			currentSelection: state.selected.versions,
			versions: state.creativeVersions.items,
			creativeDetails: state.creativeDetails,
			user: state.you,
		};
	});

	const { adType } = creativeDetails;

	const publishedVersionIds = useMemo(() => {
		return versions.reduce((prev, version) => {
			if (currentSelection.includes(version.id) && version.status === VERSION_STATUS.LIVE) {
				return [...prev, version.id];
			}
			return prev;
		}, []);
	}, [versions, currentSelection]);

	const handleClick = () => {
		dispatch(socialUnpublishVersion(publishedVersionIds));
	};

	const showButton = [
		isSocialCreative({ adType }),
		publishedVersionIds.length,
		hasPermission(user, CV, "Manage Version Library"),
	].every(item => item);

	// Conditional Render
	if (!showButton) {
		return null;
	}

	return (
		<Button
			icon="stop"
			style="block"
			onClick={handleClick}
		>
			Unpublish ({publishedVersionIds.length})
		</Button>
	);
}
